import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalInputsDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/** Matches the gateway-side PowurOS Proposal Input cache TTL */
const INPUTS_STALE_TIME_MS = 30_000

export default function useBatteryProposalInputs(
  proposalId: string | undefined,
): UseQueryResult<BatteryProposalInputsDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.inputs(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getInputs(proposalId)
    },
    enabled: Boolean(proposalId),
    staleTime: INPUTS_STALE_TIME_MS,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
